import React from 'react';

import { Skeleton } from '@material-ui/lab';
import styled from 'styled-components';

const EmptyContainer = styled.div`
  display: fixed;
  align-items: center;
  margin-left: 12px;
`;

const EmptyBlock = () => (
  <EmptyContainer>
    <Skeleton width="36px" height="6px" animation={false} />
  </EmptyContainer>
);

export default EmptyBlock;
